import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'morva-toastr-notifiction',
  templateUrl: './toastr-notifiction.component.html',
  styleUrls: ['./toastr-notifiction.component.scss'],
  /* eslint-disable */
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      transition(
        'inactive => active',
        animate(
          '300ms ease-out',
          keyframes([
            style({
              opacity: 0,
              bottom: '-15px',
              'max-height': 0,
              'max-width': 0,
              'margin-top': 0,
            }),
            style({
              opacity: 0.8,
              bottom: '-3px',
            }),
            style({
              opacity: 1,
              bottom: '0',
              'max-height': '200px',
              'margin-top': '12px',
              'max-width': '400px',
            }),
          ]),
        ),
      ),
      state(
        'active',
        style({
          bottom: '0',
          'max-height': '200px',
          'margin-top': '12px',
          'max-width': '400px',
        }),
      ),
      transition(
        'active => removed',
        animate(
          '300ms ease-out',
          keyframes([
            style({
              opacity: 1,
              transform: 'translateY(0)',
            }),
            style({
              opacity: 0,
              transform: 'translateY(25%)',
            }),
          ]),
        ),
      ),
    ]),
  ],
})
export class ToastrNotifictionComponent extends Toast {

  colors = {
    success: '#99e280',
    info: '#4DBCEB',
    error: '#F14545',
    warning: '#FFCC49',
  };
  icons = {
    success: 'success',
    info: 'info',
    error: 'error',
    warning: 'warning',
  };
  options: any;
  selectedType = { color: '', icon: '' };

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
    this.options = this.toastrService.toastrConfig;
    this.setType();

  }
  setType() {
    switch (this.options.type) {
      case 'toast-success':
        this.selectedType.icon = this.icons.success;
        this.selectedType.color = this.colors.success;
        break;
      case 'toast-info':
        this.selectedType.icon = this.icons.info;
        this.selectedType.color = this.colors.info;
        break;
      case 'toast-error':
        this.selectedType.icon = this.icons.error;
        this.selectedType.color = this.colors.error;
        break;
      case 'toast-warning':
        this.selectedType.icon = this.icons.warning;
        this.selectedType.color = this.colors.warning;
        break;
    }
  }
}
